module.exports = __webpack_public_path__ + "static/img/pizza_slide_2.08a693b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pizza_slide_2.png
// module id = 8nkr
// module chunks = 0